export default __webpack_public_path__ + "static/ISO-standard-9837ca9a4c1ec1819e454db4384dd1da.png";